export default __webpack_public_path__ + "static/media/ButtonRed3.2ac2ca03.png";